import { Construction, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function MaintenancePage({ message, onRetry }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-24 h-24 bg-amber-100 rounded-full flex items-center justify-center">
            <Construction className="w-12 h-12 text-amber-600" />
          </div>
        </div>
        
        {/* Title */}
        <h1 className="text-3xl font-bold text-slate-900">
          Under Maintenance
        </h1>
        
        {/* Message */}
        <p className="text-slate-600 text-lg">
          {message || "The app is currently under maintenance. Please check back soon."}
        </p>
        
        {/* Additional Info */}
        <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-amber-200">
          <p className="text-sm text-slate-500">
            We&apos;re working hard to improve your experience. 
            This shouldn&apos;t take long.
          </p>
        </div>
        
        {/* Retry Button */}
        <Button 
          onClick={onRetry}
          variant="outline"
          className="gap-2"
          data-testid="retry-btn"
        >
          <RefreshCw className="w-4 h-4" />
          Check Again
        </Button>
        
        {/* Footer */}
        <p className="text-xs text-slate-400">
          Discipleship Institute App
        </p>
      </div>
    </div>
  );
}
